export default "/_next/static/images/Midcentury-a0e793de2b1ef7a9badd45630c758fa6.png";